import { css } from '@emotion/react';
import { useRouter } from '@tanstack/react-router';
import { Button, Heading, Text } from '@frontend/design-system';

const NotFound = () => {
  const router = useRouter();

  return (
    <section css={notFoundContainerStyle}>
      <Heading level={1}>404 - Page Not Found</Heading>
      <Text>The page you requested could not be found.</Text>
      <Text>Current URL: {router.state.location.pathname}</Text>
      <div css={buttonContainerStyle}>
        <Button variant='primary' onClick={() => router.history.back()}>
          Go Back
        </Button>
        <Button variant='secondary' onClick={() => router.navigate({ to: '/' })}>
          Go to Home
        </Button>
      </div>
    </section>
  );
};

export default NotFound;

const notFoundContainerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  gap: var(--fabric-number-n-4-px);
`;

const buttonContainerStyle = css`
  display: flex;
  gap: var(--fabric-number-n-2-px);
`;
